import {useState} from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Divider,Box,Grid,Autocomplete,TextField,Button, InputAdornment} from "@mui/material";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Info } from '@mui/icons-material';
import ApiClient from 'helpers/ApiClient';
import dayjs from 'dayjs';

const RegistrationForm = (props:any) => {
  const [startValue, setStartValue]= useState<null>(null);
  const [endValue, setEndValue]= useState< null>(null);
  const [selectedOption, setSelectedOptions] = useState("");
  
  const initialValues = {
    name: selectedOption || "",
    postCode: "",
    street: "",
    address: "",
    town: "",
    buildingNumber: "",
    country: "",
    phoneNumber: "",
    startTime: "",
    endTime: "",
    url: "",
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Required Field"),
    postCode: Yup.string().required("Required Field"),
    street: Yup.string().required("Required Field"),
    address: Yup.string().required("Required Field"),
    town: Yup.string().required("Required Field"),
    buildingNumber: Yup.string().required("Required Field"),
    country: Yup.string().required("Required Field"),
    phoneNumber: Yup.string().required("Required Field"),
    url: Yup.string().required("Required Field"),
  });
  const { values, touched, errors, handleChange, handleBlur, handleSubmit, resetForm } = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async () => {
      const chargingParams={
        ...values,
         name : selectedOption,
         startTime:dayjs(startValue).format('HH:MM'),
         endTime:dayjs(endValue).format('HH:MM'),
         coordinates:'79.8,28.6'
       }
       
      try {
         const response= await ApiClient.post('manage-services/add-charging-station',chargingParams)
         props.setToggleSnackbar({ message: "Charging Station registered successfully", isToggle: true, mode: "success"});
         props.back()
       } catch (error) {
       }

      resetForm();
      setStartValue(null);
      setEndValue(null);
      setSelectedOptions("");
    },
  });
  const top100Films = [
    { title: 'Station 1'},
    { title: 'Station 2'},
    { title: 'Station 3'},
    { title: 'Station 4'},
    { title: 'Station 5'},
  ]
  
  return (
    <Box className="chargingStation border-radius-8">
      <h3 className="main-heading fs-20 fw-700 grey-color">Register Charging Station</h3>
      <Divider />
        <Grid container spacing={2} className="station-form">
          <Grid item lg={8}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <label htmlFor="name"  className={errors.name && touched.name ?"error-color":"label-color"}>Charging Station Name <span style={{color:'red'}}>*</span></label>
                    <Autocomplete
                      id="name"
                      sx={{mt:0.5}}
                      onInputChange={(event, value) => setSelectedOptions(value)}
                      options={top100Films.map((option) => option.title)}
                      freeSolo
                      renderInput={(params) => 
                        <TextField
                        {...params}
                        name="name"
                        fullWidth
                        type="text"
                        variant="outlined"
                        error={!!(errors.name && touched.name)}
                        value={values.name}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <InputAdornment position="end" sx={{ paddingRight: "12px" }}>
                              {(errors.name && touched.name) && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}
                            </InputAdornment>
                          ),
                        }}
                      />}
                    />
                    {errors.name && touched.name && <small className="error-color">Required field*</small>}
                </Grid>
                <Grid item xs={12}>
                  <h4>Address</h4>
                </Grid>
                <Grid item xs={12} md={6}>
                    <label htmlFor="postCode" className={errors.postCode && touched.postCode?"error-color":"label-color"}>Post Code <span style={{color:'red'}}>*</span></label>
                    <TextField 
                    error={!!(errors.postCode && touched.postCode)}  onBlur={handleBlur}
                    onChange={handleChange} id="postCode" name="postCode" fullWidth sx={{mt:0.5}} value={values.postCode}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{errors.postCode && touched.postCode && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                    }}
                    />
                    {errors.postCode && touched.postCode && <small className="error-color">Required Field</small>  }
                </Grid>
                <Grid item xs={12} md={6}>
                    <label htmlFor="street" className={errors.street && touched.street?"error-color":"label-color"}>Street or Road Name <span style={{color:'red'}}>*</span></label>
                    <TextField error={!!(errors.street && touched.street)}  onBlur={handleBlur} 
                      onChange={handleChange}  id="street" name="street" fullWidth sx={{mt:0.5}} value={values.street}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{errors.street && touched.street && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                      }}
                      />
                    {errors.street && touched.street && <small className="error-color">Required Field</small>  }
                </Grid>
                <Grid item xs={12} md={6}>
                    <label htmlFor="address" className={errors.address && touched.address?"error-color":"label-color"}>Address <span style={{color:'red'}}>*</span></label>
                    <TextField error={!!(errors.address && touched.address)}   onBlur={handleBlur} 
                      onChange={handleChange} id="address" name="address" fullWidth sx={{mt:0.5}} value={values.address}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{errors.address && touched.address && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                      }}
                      />
                    {errors.address && touched.address && <small className="error-color">Required Field</small>  }
                </Grid>
                <Grid item xs={12} md={6}>
                    <label htmlFor="town" className={errors.town && touched.town?"error-color":"label-color"}>Town <span style={{color:'red'}}>*</span></label>
                    <TextField error={!!(errors.town && touched.town)}  onBlur={handleBlur} 
                      onChange={handleChange}  id="town" name="town" fullWidth sx={{mt:0.5}} value={values.town}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{errors.town && touched.town && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                      }}
                      />
                    {errors.town && touched.town && <small className="error-color">Required Field</small>  }
                </Grid>
                <Grid item xs={12} md={6}>
                    <label htmlFor="buildingNumber"className={errors.buildingNumber && touched.buildingNumber?"error-color":"label-color"}>Building Number <span style={{color:'red'}}>*</span></label>
                    <TextField error={!!(errors.buildingNumber && touched.buildingNumber)}  onBlur={handleBlur} 
                      onChange={handleChange}  id="buildingNumber" name="buildingNumber" fullWidth sx={{mt:0.5}} value={values.buildingNumber}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{errors.buildingNumber && touched.buildingNumber && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                      }}
                      />
                    {errors.buildingNumber && touched.buildingNumber && <small className="error-color">Required Field</small>  }
                </Grid>
                <Grid item xs={12} md={6}>
                    <label htmlFor="country" className={errors.country && touched.country?"error-color":"label-color"}>Country <span style={{color:'red'}}>*</span></label>
                    <TextField error={!!(errors.country && touched.country)}  onBlur={handleBlur} 
                      onChange={handleChange}  id="country" name="country" fullWidth sx={{mt:0.5}} value={values.country}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">{errors.country && touched.country && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                      }}
                      />
                    {errors.country && touched.country && <small className="error-color">Required Field</small>  }
                </Grid>
                <Grid item xs={12}>
                <h4>Business Details</h4>
                </Grid>
                <Grid item xs={12} md={6.1}>
                  <label htmlFor="phoneNumber" className={errors.phoneNumber && touched.phoneNumber?"error-color":"label-color"} >Phone Number <span style={{color:'red'}}>*</span></label>
                  <TextField error={!!(errors.phoneNumber && touched.phoneNumber)} onBlur={handleBlur} 
                    onChange={handleChange}  id="phoneNumber" name="phoneNumber" placeholder="Enter Number" fullWidth sx={{mt:0.5}} value={values.phoneNumber}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{errors.phoneNumber && touched.phoneNumber && <Info sx={{ color: "#DC3545" }} fontSize="medium"/>}</InputAdornment>,
                    }}
                    />
                  {errors.phoneNumber && touched.phoneNumber && <small  className="error-color">Required Field</small>  }
                </Grid>
                <Grid item md={6.1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <label htmlFor="startTime" >Start Time <span style={{color:'red'}}>*</span></label>
                      <LocalizationProvider dateAdapter={AdapterMoment} >
                        <TimePicker  value={startValue} onChange={(newValue) => {setStartValue(newValue)}}
                          renderInput={(params) => <TextField  fullWidth  {...params} name="startTime"/>}/>
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <label htmlFor="endTime">End Time <span style={{color:'red'}}>*</span></label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <TimePicker value={endValue} onChange={(newValue) => {setEndValue(newValue)}}
                            renderInput={(params) => <TextField   fullWidth  {...params} name="endTime" />}/>
                        </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6.1}> 
                  <label htmlFor="url" className={errors.url && touched.url?"error-color":"label-color"}>Website <span style={{color:'red'}}>*</span></label>
                  <TextField error={!!(errors.url && touched.url)}  onBlur={handleBlur} 
                  onChange={handleChange}  id="url" name="url" placeholder="Enter URL" fullWidth sx={{mt:0.5}} value={values.url}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">{errors.url && touched.url && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}</InputAdornment>,
                  }}
                  />
                  {errors.url && touched.url && <small className="error-color">Required Field</small>  }
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{display:"flex",justifyContent:"space-between",mt:4}}>
                <Button sx={{color:"black"}} onClick={props.back}>Back</Button>
                <button type="submit" className="btn-primary">Save</button>
              </Grid>
            </form>
          </Grid>
        </Grid>
    </Box>
  );
};

export default RegistrationForm;
